import type { Resource } from "./Resource.js";
import type { Nullable } from "./types.js";

export type FieldType =
  | "string"
  | "integer"
  | "negativeInteger"
  | "nonNegativeInteger"
  | "positiveInteger"
  | "nonPositiveInteger"
  | "number"
  | "decimal"
  | "double"
  | "float"
  | "boolean"
  | "date"
  | "dateTime"
  | "duration"
  | "time"
  | "byte"
  | "binary"
  | "hexBinary"
  | "base64Binary"
  | "array"
  | "object"
  | "email"
  | "url"
  | "uuid"
  | "password"
  // oxlint-disable-next-line ban-types
  | ({} & string); // Allow any other string type

export interface FieldOptions
  extends Nullable<{
    id?: string;
    range?: string;
    type?: FieldType;
    arrayType?: FieldType;
    enum?: { [key: string | number]: string | number };
    reference?: string | Resource;
    embedded?: Resource;
    nullable?: boolean;
    required?: boolean;
    description?: string;
    maxCardinality?: number;
    deprecated?: boolean;
  }> {}

export class Field implements FieldOptions {
  name: string;

  id?: string | null;
  range?: string | null;
  type?: FieldType | null;
  arrayType?: FieldType | null;
  enum?: { [key: string | number]: string | number } | null;
  reference?: string | Resource | null;
  embedded?: Resource | null;
  nullable?: boolean | null;
  required?: boolean | null;
  description?: string | null;
  maxCardinality?: number | null;
  deprecated?: boolean | null;

  constructor(name: string, options: FieldOptions = {}) {
    this.name = name;
    Object.assign(this, options);
  }
}
